import React from 'react';
import Sections from './Sections';
import Data from '../../../../Data';

export default () => <Sections />;
